module.exports = {"NAVEGACAO":{"HOME":"Home","ABOUT_ME":"About me","CONTACT":"Contact","WORK":"Work"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/pt-BR.json
// module id = 406
// module chunks = 0